'use strict';

var variables = require('./variables-1eb6495a.js');

const light = {
    root: {
        padding: "0px 8px 0px 16px",
        borderBottom: `1px solid ${variables.COLORS.GREYSCALE_85}`,
        borderRight: `1px solid ${variables.COLORS.GREYSCALE_85}`,
        height: "39px",
    },
    head: {
        height: "41px",
        fontWeight: variables.WEIGHTS.MEDIUM,
        backgroundColor: variables.COLORS.GREYSCALE_98,
    },
    paddingCheckbox: {
        width: "40px",
        padding: "0px",
    },
    sizeSmall: {
        padding: "0px 8px",
        height: "29px",
        "&$head": {
            height: "31px",
        },
        "&$paddingCheckbox": {
            width: "40px",
            padding: "0px",
        },
    },
    stickyHeader: {
        backgroundColor: variables.COLORS.GREYSCALE_98,
        borderBottom: `1px solid ${variables.COLORS.GREYSCALE_85}`,
    },
};

var MuiTableCell = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiTableCell = MuiTableCell;
exports.light = light;
